import { IoIosArrowDown } from 'react-icons/io'
import { useCallback, useEffect } from 'react';
import FrontMenuSection from './FrontMenuSection.jsx';
import { Link } from 'react-router-dom';



const obseques_sections =
[
	[
		{ label: 'Urgence décès 24/7', path: '/obseques/urgence-deces' },
		{ label: 'Organiser des obsèques', path: '/obseques' },
		{ label: 'Crémation', path: '/obseques/cremation' }
	],
	[
		{ label: 'Inhumation', path: '/obseques/inhumation' },
		{ label: 'Avis de décès', path: '/avis-de-deces' },
		{ label: 'Obtenir un devis obsèques', path: '/obseques/devis-obseques' }
	],
	[
		{ label: 'Cérémonie civile ou religieuse', path: '/obseques/types-ceremonie' },
		{ label: 'Inhumation ou crémation', path: '/obseques/inhumation-ou-cremation' },
		{ label: 'Les étapes de l\'organisation d\'obsèques', path: '/obseques/etapes-organisation-obseques' }
	]
]

const fleurs_plaques_sections =
[
	[
		{ label: 'Livrer des fleurs de deuil', path: '/fleurs-et-plaques/livrer-des-fleurs' },
		{ label: 'Catalogue plaques', path: '/fleurs-et-plaques/catalogue-plaques' }
	],
	[
		{ label: 'Catalogue fleurs', path: '/fleurs-et-plaques/catalogue-fleurs' },
		{ label: 'Commander un fleurissement', path: '/fleurs-et-plaques/commande-fleurissement' }
	]
]

const marbrerie_sections =
[
	[
		{ label: 'Choisir un monument', path: '/marbrerie/choisir-un-monument' },
		{ label: 'Choisir un caveau', path: '/marbrerie/choisir-un-caveau' },
		{ label: 'Configurer un monument 3D', path: '/marbrerie/configurer-monument' },
		{ label: 'Les travaux de marbrerie', path: '/marbrerie' }
	],
	[
		{ label: 'Commander un nettoyage', path: '/marbrerie/commander-un-nettoyage' },
		{ label: 'Rénover une sépulture', path: '/marbrerie/renover-une-sepulture' }
	],
	[
		{ label: 'Pourquoi et comment entretenir un monument', path: '/marbrerie/entretenir-un-monument' },
		{ label: 'Quelle couleur de granit choisir', path: '/marbrerie/quelle-couleur-de-granit-choisir' }
	]
]

const assurance_sections =
[
	[
		{ label: 'Assurance obsèques Sotraf', path: '/assurance-obseques' },
		{ label: 'Découvrir nos deux contrats', path: '/assurance-obseques/nos-deux-contrats' },
		{ label: 'Obtenir un devis assurance obsèques', path: '/assurance-obseques/obtenir-un-devis' }
	],
	[
		{ label: 'Les 5 questions à se poser', path: '/assurance-obseques/conseils' },
		{ label: 'Comment préparer ses obsèques', path: '/assurance-obseques/preparer-ses-obseques' },
		{ label: 'Comprendre un devis assurance obsèques', path: '/assurance-obseques/comprendre-un-devis' }
	]
]

export default function FrontMenuItems ({ ...props })
{

	useEffect(() => {
		let sub_menu_ouvert = document.getElementsByClassName("f-header__nav--categories__active")[0];

		if (sub_menu_ouvert) {
			let btn_sub_menu_ouvert = sub_menu_ouvert.previousElementSibling;
			let icon_sub_menu_ouvert = sub_menu_ouvert.previousSibling.childNodes[1];

			sub_menu_ouvert.className = 'f-header__nav--categories';
			icon_sub_menu_ouvert.setAttribute('class', 'f-header__nav--icon');
			btn_sub_menu_ouvert.className = 'f-header__btn--categories';
		}
	});

	const handleSubOpen = useCallback(function (name)
	{
		let btn_sub_menu = document.getElementById("btn_" + name);
		let sub_menu = document.getElementById("ul_" + name);
		let section_icon = document.getElementById("icon_" + name);

		let sub_menu_ouvert = document.getElementsByClassName("f-header__nav--categories__active")[0];
		
		//Fermeture du menu déjà ouvert
		if (sub_menu_ouvert)
		{
			let btn_sub_menu_ouvert = sub_menu_ouvert.previousElementSibling;
			let icon_sub_menu_ouvert = sub_menu_ouvert.previousSibling.childNodes[1];

			closeSubMenu(sub_menu_ouvert, btn_sub_menu_ouvert, icon_sub_menu_ouvert);
		}

		//Appliquer au 1re ou nouveau sous-menu
		if (!sub_menu_ouvert || sub_menu_ouvert !== sub_menu)
		{
			openSubMenu(sub_menu, btn_sub_menu, section_icon);
		}

	},
	[]);

	const section_obseques = obseques_sections.map((section) => {
		return (
			<li key={ section.label }>
				<FrontMenuSection items={ section } categorie="obseques" />
			</li>
		)
	});

	const section_fleurs_plaques = fleurs_plaques_sections.map((section) => {
		return (
			<li key={ section.label }>
				<FrontMenuSection items={ section } categorie="fleurs_plaques" />
			</li>
		)
	});

	const section_marbrerie = marbrerie_sections.map((section) => {
		return (
			<li key={ section.label }>
				<FrontMenuSection items={ section } categorie="marbrerie" />
			</li>
		)
	});

	const section_assurance = assurance_sections.map((section) => {
		return (
			<li key={ section.label }>
				<FrontMenuSection items={ section } categorie="assurance_obseques" />
			</li>
		)
	});

	return (
		<ul className="f-header__nav--wrapper">
			<li key="obseques">
				<button type="button" id="btn_obseques" className="f-header__btn--categories"
					onClick={ e => handleSubOpen("obseques") }>
					<span className="f-header__nav--link">
						Obsèques
					</span>
					<IoIosArrowDown id="icon_obseques" className='f-header__nav--icon' />
				</button>
				<ul id="ul_obseques" className="f-header__nav--categories">
					{ section_obseques }
					<li className='f-header__nav--devis'>
						<h5 className='f-header__nav--devis__title'>
							Devis obsèques
						</h5>
						<p className='u-margin-bottom-25'>
							Contactez-nous pour l'organisation d'obsèques
						</p>
						<Link to="/obseques/devis-obseques" className='f-header__nav--devis__btn'>
							Devis obsèques
						</Link>
					</li>
				</ul>
			</li>
			<li key="fleurs_plaques">
				<button type="button" id="btn_fleurs_plaques" className="f-header__btn--categories"
					onClick={ e => handleSubOpen("fleurs_plaques") }>
					<span className="f-header__nav--link">
						Fleurs et plaques
					</span>
					<IoIosArrowDown id="icon_fleurs_plaques" className='f-header__nav--icon' />
				</button>
				<ul id="ul_fleurs_plaques" className="f-header__nav--categories">
					{ section_fleurs_plaques }
					<li className='f-header__nav--devis'>
						<h5 className='f-header__nav--devis__title'>
							Fleurissement
						</h5>
						<p className='u-margin-bottom-25'>
							Commandez un fleurissement
						</p>
						<Link to="/contact" className='f-header__nav--devis__btn'>
							Contactez-nous
						</Link>
					</li>
				</ul>
			</li>
			<li key="marbrerie">
				<button type="button" id="btn_marbrerie" className="f-header__btn--categories"
					onClick={ e => handleSubOpen("marbrerie") }>
					<span className="f-header__nav--link">
						Marbrerie
					</span>
					<IoIosArrowDown id="icon_marbrerie" className='f-header__nav--icon' />
				</button>
				<ul id="ul_marbrerie" className="f-header__nav--categories">
					{ section_marbrerie }
					<li className='f-header__nav--devis'>
						<h5 className='f-header__nav--devis__title'>
							Devis marbrerie
						</h5>
						<p className='u-margin-bottom-25'>
							Réalisation et pose de monuments
						</p>
						<Link to="/marbrerie/devis" className='f-header__nav--devis__btn'>
							Devis marbrerie
						</Link>
					</li>
				</ul>
			</li>
			<li key="assurance_obseques">
				<button type="button" id="btn_assurance_obseques" className="f-header__btn--categories"
					onClick={ e => handleSubOpen("assurance_obseques") }>
					<span className="f-header__nav--link">
						Assurance obsèques
					</span>
					<IoIosArrowDown id="icon_assurance_obseques" className='f-header__nav--icon' />
				</button>
				<ul id="ul_assurance_obseques" className="f-header__nav--categories">
					{ section_assurance }
					<li className='f-header__nav--devis'>
						<h5 className='f-header__nav--devis__title'>
							Devis assurance obsèques
						</h5>
						<p className='u-margin-bottom-25'>
							Obtenez un devis assurance obsèques
						</p>
						<Link to="/assurance-obseques/devis" className='f-header__nav--devis__btn'>
							Devis assurance obsèques
						</Link>
					</li>
				</ul>
			</li>
			<li className='f-header__nav--actualites'>
				<Link to="/actualites">
					Actualités
				</Link>
			</li>
		</ul>
	);
}

function openSubMenu(sub_menu, btn, icon)
{
	sub_menu.className = 'f-header__nav--categories__active';
	icon.setAttribute('class', 'f-header__nav--icon__clicked');
	btn.className = 'f-header__btn--categories__clicked';
}

function closeSubMenu(sub_menu, btn, icon)
{
	sub_menu.className = 'f-header__nav--categories';
	icon.setAttribute('class', 'f-header__nav--icon');
	btn.className = 'f-header__btn--categories';
}